import { ChevronRight } from "@mui/icons-material";
import { List, ListItemButton, ListSubheader, Typography } from "@mui/material";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

import { groupObservationsByType } from "../../utils/groupObservationsByType";
import { ProjectReviewVisitV2ObservationListItem } from "./ProjectReviewVisitV2ObservationListItem";
import { ProjectReviewVisitV2ObservationListItemFragment } from "./ProjectReviewVisitV2ObservationListItem/fragments.generated";

type Props = {
    createTo: (observation: ProjectReviewVisitV2ObservationListItemFragment) => To;
    observations: ProjectReviewVisitV2ObservationListItemFragment[];
};

export function ProjectReviewVisitV2ObservationList({ createTo, observations }: Props) {
    const { t } = useTranslation("project");

    const groupedObservations = useMemo(() => groupObservationsByType(observations), [observations]);

    return (
        <List sx={{ padding: 0 }}>
            {observations.length < 1 && (
                <Typography padding={2} color="textSecondary">
                    {t("projectReviewVisitV2.observationsRoute.noObservations")}
                </Typography>
            )}
            {groupedObservations.map(({ id: groupId, name, observations: groupObservations }) => (
                <Fragment key={groupId}>
                    <ListSubheader
                        sx={theme => ({
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            backgroundColor: theme.palette.background.default,
                        })}
                    >
                        <Typography flex={1} variant="overline" fontWeight="bold">
                            {name}
                        </Typography>
                    </ListSubheader>
                    {groupObservations.map(observation => (
                        <ListItemButton key={observation.id} component={Link} to={createTo(observation)}>
                            <ProjectReviewVisitV2ObservationListItem observation={observation} />
                            <ChevronRight />
                        </ListItemButton>
                    ))}
                </Fragment>
            ))}
        </List>
    );
}
